import React from "react";
import { Box, Text } from "@catchoftheday/cg-components";
import { CurrentBenefit } from "./CurrentBenefit";
import { FreeDelivery } from "./FreeDelivery";
import { PersonalisedOffer } from "./PersonalisedOffer";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var MobileWrapper = function MobileWrapper() {
  return ___EmotionJSX(Box, {
    borderRadius: "corner",
    borderColor: "onePass.primaryDarker",
    borderStyle: "solid",
    borderWidth: "1px",
    overflow: "hidden"
  }, ___EmotionJSX(Box, {
    py: 5,
    px: 4
  }, ___EmotionJSX(CurrentBenefit, null)), ___EmotionJSX(Box, {
    p: 4,
    backgroundColor: "onePass.primaryDarker",
    color: "white"
  }, ___EmotionJSX(Text, {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "base",
    m: 0
  }, "+ PLUS"), ___EmotionJSX(Box, {
    py: 4,
    borderColor: "white",
    borderStyle: "solid",
    borderWidth: 0,
    borderBottomWidth: "1px"
  }, ___EmotionJSX(FreeDelivery, null)), ___EmotionJSX(Box, {
    pt: 4
  }, ___EmotionJSX(PersonalisedOffer, null))));
};